import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotesAndCommunicationComponent } from './notes-and-communication.component';
import { FormsModule } from '@angular/forms';
import { PipesModule } from 'src/app/core/pipes/pipes.module';
import { EmailHtmlEditorModule } from '../../email-html-editor/email-html-editor.module';
import { AiAssistantModule } from '../../ai-assistant/ai-assistant.module';
import { VoiceInputModule } from '../../ai-assistant/voice-input/voice-input.module';

@NgModule({
  declarations: [NotesAndCommunicationComponent],
  imports: [
    CommonModule,
    FormsModule,
    PipesModule,
    EmailHtmlEditorModule,
    AiAssistantModule,
    VoiceInputModule
  ],
  providers: [NotesAndCommunicationComponent],
  entryComponents: [NotesAndCommunicationComponent],
  exports: [NotesAndCommunicationComponent]
})
export class NotesAndCommunicationModule { }
